import { jsx as _jsx } from "react/jsx-runtime";
import { useState, useEffect, useCallback } from 'react';
import Modal from './Modal';
import LoginForm from './LoginForm';
/**
 * Global re-authentication modal.
 *
 * Listens for the custom "session-expired" DOM event (dispatched by api.ts
 * when a 401 is received) and shows a login form inside a modal so the user
 * can re-authenticate without losing their on-screen context.
 */
const SessionExpiredModal = () => {
    const [open, setOpen] = useState(false);
    useEffect(() => {
        const handleSessionExpired = () => setOpen(true);
        window.addEventListener('session-expired', handleSessionExpired);
        return () => window.removeEventListener('session-expired', handleSessionExpired);
    }, []);
    const handleLogin = useCallback(async (email, password) => {
        const response = await fetch('/users/login', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
                'Accept': 'application/json',
            },
            credentials: 'include',
            body: new URLSearchParams({ email, password }),
        });
        const data = await response.json();
        if (!response.ok || !data.success) {
            throw new Error(data.error || 'Invalid email or password');
        }
        setOpen(false);
        window.dispatchEvent(new CustomEvent('session-restored'));
    }, []);
    return (_jsx(Modal, { open: open, onClose: () => { }, title: "Session expired", description: "Your session has expired. Please log in again to continue.", size: "sm", showCloseButton: false, children: _jsx(LoginForm, { onSubmit: handleLogin, submitLabel: "Log back in" }) }));
};
export default SessionExpiredModal;
